export default "__VITE_ASSET__DvOYP6mm__"